module.exports = __webpack_public_path__ + "img/arrow-goes-top-bottom-icon.9774fcee.svg";